import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IntRange } from '../../models/int-range/int-range';

export function outOfRangeValidator(
  range: IntRange,
  deTransform?: (rating: number) => number,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let value: number = control.value;
    if (deTransform) {
      value = deTransform(control.value);
    }
    const outOfRange: boolean = range.outOfRange(value);
    return outOfRange ? { outOfRange: { value: value } } : null;
  };
}
